export const periodicTableData = {
  "H": { "name": "Hydrogen", "group": "nonmetal", "period": 1, "column": 1 },
  "He": { "name": "Helium", "group": "noble", "period": 1, "column": 18 },
  "Li": { "name": "Lithium", "group": "alkali", "period": 2, "column": 1 },
  "Be": { "name": "Beryllium", "group": "alkaline", "period": 2, "column": 2 },
  "B": { "name": "Boron", "group": "metalloid", "period": 2, "column": 13 },
  "C": { "name": "Carbon", "group": "nonmetal", "period": 2, "column": 14 },
  "N": { "name": "Nitrogen", "group": "nonmetal", "period": 2, "column": 15 },
  "O": { "name": "Oxygen", "group": "nonmetal", "period": 2, "column": 16 },
  "F": { "name": "Fluorine", "group": "nonmetal", "period": 2, "column": 17 },
  "Ne": { "name": "Neon", "group": "noble", "period": 2, "column": 18 },
  "Na": { "name": "Sodium", "group": "alkali", "period": 3, "column": 1 },
  "Mg": { "name": "Magnesium", "group": "alkaline", "period": 3, "column": 2 },
  "Al": { "name": "Aluminum", "group": "post-transition", "period": 3, "column": 13 },
  "Si": { "name": "Silicon", "group": "metalloid", "period": 3, "column": 14 },
  "P": { "name": "Phosphorus", "group": "nonmetal", "period": 3, "column": 15 },
  "S": { "name": "Sulfur", "group": "nonmetal", "period": 3, "column": 16 },
  "Cl": { "name": "Chlorine", "group": "nonmetal", "period": 3, "column": 17 },
  "Ar": { "name": "Argon", "group": "noble", "period": 3, "column": 18 },
  "K": { "name": "Potassium", "group": "alkali", "period": 4, "column": 1 },
  "Ca": { "name": "Calcium", "group": "alkaline", "period": 4, "column": 2 },
  "Sc": { "name": "Scandium", "group": "transition", "period": 4, "column": 3 },
  "Ti": { "name": "Titanium", "group": "transition", "period": 4, "column": 4 },
  "V": { "name": "Vanadium", "group": "transition", "period": 4, "column": 5 },
  "Cr": { "name": "Chromium", "group": "transition", "period": 4, "column": 6 },
  "Mn": { "name": "Manganese", "group": "transition", "period": 4, "column": 7 },
  "Fe": { "name": "Iron", "group": "transition", "period": 4, "column": 8 },
  "Co": { "name": "Cobalt", "group": "transition", "period": 4, "column": 9 },
  "Ni": { "name": "Nickel", "group": "transition", "period": 4, "column": 10 },
  "Cu": { "name": "Copper", "group": "transition", "period": 4, "column": 11 },
  "Zn": { "name": "Zinc", "group": "transition", "period": 4, "column": 12 },
  "Ga": { "name": "Gallium", "group": "post-transition", "period": 4, "column": 13 },
  "Ge": { "name": "Germanium", "group": "metalloid", "period": 4, "column": 14 },
  "As": { "name": "Arsenic", "group": "metalloid", "period": 4, "column": 15 },
  "Se": { "name": "Selenium", "group": "nonmetal", "period": 4, "column": 16 },
  "Br": { "name": "Bromine", "group": "nonmetal", "period": 4, "column": 17 },
  "Kr": { "name": "Krypton", "group": "noble", "period": 4, "column": 18 },
  "Rb": { "name": "Rubidium", "group": "alkali", "period": 5, "column": 1 },
  "Sr": { "name": "Strontium", "group": "alkaline", "period": 5, "column": 2 },
  "Y": { "name": "Yttrium", "group": "transition", "period": 5, "column": 3 },
  "Zr": { "name": "Zirconium", "group": "transition", "period": 5, "column": 4 },
  "Nb": { "name": "Niobium", "group": "transition", "period": 5, "column": 5 },
  "Mo": { "name": "Molybdenum", "group": "transition", "period": 5, "column": 6 },
  "Tc": { "name": "Technetium", "group": "transition", "period": 5, "column": 7 },
  "Ru": { "name": "Ruthenium", "group": "transition", "period": 5, "column": 8 },
  "Rh": { "name": "Rhodium", "group": "transition", "period": 5, "column": 9 },
  "Pd": { "name": "Palladium", "group": "transition", "period": 5, "column": 10 },
  "Ag": { "name": "Silver", "group": "transition", "period": 5, "column": 11 },
  "Cd": { "name": "Cadmium", "group": "transition", "period": 5, "column": 12 },
  "In": { "name": "Indium", "group": "post-transition", "period": 5, "column": 13 },
  "Sn": { "name": "Tin", "group": "post-transition", "period": 5, "column": 14 },
  "Sb": { "name": "Antimony", "group": "metalloid", "period": 5, "column": 15 },
  "Te": { "name": "Tellurium", "group": "metalloid", "period": 5, "column": 16 },
  "I": { "name": "Iodine", "group": "nonmetal", "period": 5, "column": 17 },
  "Xe": { "name": "Xenon", "group": "noble", "period": 5, "column": 18 },
  "Cs": { "name": "Cesium", "group": "alkali", "period": 6, "column": 1 },
  "Ba": { "name": "Barium", "group": "alkaline", "period": 6, "column": 2 },
  "Hf": { "name": "Hafnium", "group": "transition", "period": 6, "column": 4 },
  "Ta": { "name": "Tantalum", "group": "transition", "period": 6, "column": 5 },
  "W": { "name": "Tungsten", "group": "transition", "period": 6, "column": 6 },
  "Re": { "name": "Rhenium", "group": "transition", "period": 6, "column": 7 },
  "Os": { "name": "Osmium", "group": "transition", "period": 6, "column": 8 },
  "Ir": { "name": "Iridium", "group": "transition", "period": 6, "column": 9 },
  "Pt": { "name": "Platinum", "group": "transition", "period": 6, "column": 10 },
  "Au": { "name": "Gold", "group": "transition", "period": 6, "column": 11 },
  "Hg": { "name": "Mercury", "group": "transition", "period": 6, "column": 12 },
  "Tl": { "name": "Thallium", "group": "post-transition", "period": 6, "column": 13 },
  "Pb": { "name": "Lead", "group": "post-transition", "period": 6, "column": 14 },
  "Bi": { "name": "Bismuth", "group": "post-transition", "period": 6, "column": 15 },
  "Po": { "name": "Polonium", "group": "metalloid", "period": 6, "column": 16 },
  "At": { "name": "Astatine", "group": "nonmetal", "period": 6, "column": 17 },
  "Rn": { "name": "Radon", "group": "noble", "period": 6, "column": 18 },
  "La": { "name": "Lanthanum", "group": "lanthanide", "period": 6, "column": 3 },
  "Ce": { "name": "Cerium", "group": "lanthanide", "period": 6, "column": 4 },
  "Pr": { "name": "Praseodymium", "group": "lanthanide", "period": 6, "column": 5 },
  "Nd": { "name": "Neodymium", "group": "lanthanide", "period": 6, "column": 6 },
  "Pm": { "name": "Promethium", "group": "lanthanide", "period": 6, "column": 7 },
  "Sm": { "name": "Samarium", "group": "lanthanide", "period": 6, "column": 8 },
  "Eu": { "name": "Europium", "group": "lanthanide", "period": 6, "column": 9 },
  "Gd": { "name": "Gadolinium", "group": "lanthanide", "period": 6, "column": 10 },
  "Tb": { "name": "Terbium", "group": "lanthanide", "period": 6, "column": 11 },
  "Dy": { "name": "Dysprosium", "group": "lanthanide", "period": 6, "column": 12 },
  "Ho": { "name": "Holmium", "group": "lanthanide", "period": 6, "column": 13 },
  "Er": { "name": "Erbium", "group": "lanthanide", "period": 6, "column": 14 },
  "Tm": { "name": "Thulium", "group": "lanthanide", "period": 6, "column": 15 },
  "Yb": { "name": "Ytterbium", "group": "lanthanide", "period": 6, "column": 16 },
  "Lu": { "name": "Lutetium", "group": "lanthanide", "period": 6, "column": 17 },
  "Ac": { "name": "Actinium", "group": "actinide", "period": 7, "column": 3 },
  "Th": { "name": "Thorium", "group": "actinide", "period": 7, "column": 4 },
  "Pa": { "name": "Protactinium", "group": "actinide", "period": 7, "column": 5 },
  "U": { "name": "Uranium", "group": "actinide", "period": 7, "column": 6 },
  "Np": { "name": "Neptunium", "group": "actinide", "period": 7, "column": 7 },
  "Pu": { "name": "Plutonium", "group": "actinide", "period": 7, "column": 8 },
  "Am": { "name": "Americium", "group": "actinide", "period": 7, "column": 9 },
  "Cm": { "name": "Curium", "group": "actinide", "period": 7, "column": 10 },
  "Bk": { "name": "Berkelium", "group": "actinide", "period": 7, "column": 11 },
  "Cf": { "name": "Californium", "group": "actinide", "period": 7, "column": 12 },
  "Es": { "name": "Einsteinium", "group": "actinide", "period": 7, "column": 13 },
  "Fm": { "name": "Fermium", "group": "actinide", "period": 7, "column": 14 },
  "Md": { "name": "Mendelevium", "group": "actinide", "period": 7, "column": 15 },
  "No": { "name": "Nobelium", "group": "actinide", "period": 7, "column": 16 },
  "Lr": { "name": "Lawrencium", "group": "actinide", "period": 7, "column": 17 },
  // New elements to add:
  "Fr": { "name": "Francium", "group": "alkali", "period": 7, "column": 1 },
  "Ra": { "name": "Radium", "group": "alkaline", "period": 7, "column": 2 },
  "Rf": { "name": "Rutherfordium", "group": "transition", "period": 7, "column": 4 },
  "Db": { "name": "Dubnium", "group": "transition", "period": 7, "column": 5 },
  "Sg": { "name": "Seaborgium", "group": "transition", "period": 7, "column": 6 },
  "Bh": { "name": "Bohrium", "group": "transition", "period": 7, "column": 7 },
  "Hs": { "name": "Hassium", "group": "transition", "period": 7, "column": 8 },
  "Mt": { "name": "Meitnerium", "group": "transition", "period": 7, "column": 9 },
  "Ds": { "name": "Darmstadtium", "group": "transition", "period": 7, "column": 10 },
  "Rg": { "name": "Roentgenium", "group": "transition", "period": 7, "column": 11 },
  "Cn": { "name": "Copernicium", "group": "transition", "period": 7, "column": 12 },
  "Nh": { "name": "Nihonium", "group": "post-transition", "period": 7, "column": 13 },
  "Fl": { "name": "Flerovium", "group": "post-transition", "period": 7, "column": 14 },
  "Mc": { "name": "Moscovium", "group": "post-transition", "period": 7, "column": 15 },
  "Lv": { "name": "Livermorium", "group": "post-transition", "period": 7, "column": 16 },
  "Ts": { "name": "Tennessine", "group": "nonmetal", "period": 7, "column": 17 },
  "Og": { "name": "Oganesson", "group": "noble", "period": 7, "column": 18 }
};

  export default periodicTableData;